import { httpClient } from "@/services";
import requestKeys from "@/constants/requestKeys";
import BrokersHeaders from "@/pages/Maintenance/Brokers/brokersHeaders";

export default {
	state: {
		brokersItem: null,
		brokersList: null,
		brokersFilters: null,
		brokersTotals: null,
		brokersLimit: null,
		brokersOrder: null,
		brokersSort: null,
		brokersTotal: null,
	},
	mutations: {
		updateBrokersList(state, { rows, limit, order, sort, total }) {
			state.brokersList = rows;
			state.brokersLimit = limit;
			state.brokersOrder = order;
			state.brokersSort = sort;
			state.brokersTotal = total;
			state.brokersTotals = { id: total };
		},
		updateBrokersFilters(state, { filter }) {
			state.brokersFilters = filter;
		},
		getDriverDeleteFiles({ commit }, { id, isDelete }) {
			commit('updateDriverDeleteFiles', { id, isDelete });
		},
		updateBrokersItem(state, { broker }) {
			state.brokersItem = broker;
		}
	},
	actions: {
		async getBrokers({ commit, dispatch }, filters) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post('/broker/list', filters);

				if (data && !data.status) {
					commit('updateBrokersList', data);
					commit('updateSettings', { settings: data.settings, key: requestKeys.TRUCKS, defaultHeader: BrokersHeaders });
				}
			} catch (error) {
				console.error(error);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		async getBrokersFilters({ commit }, values) {
			try {
				const { data } = await httpClient.post('/broker/filters', values);
				if (data) commit('updateBrokersFilters', data);
			} catch (e) {
				console.error(e);
			}
		},

		async onBrokersSave({ dispatch }, { values, id }) {
			dispatch("actionPreloader", true);
			const requestUrl = id ? `/broker/${ id }` : '/broker';
			const requestKey = id ? 'put' : 'post';
			try {
				const { data } = await httpClient[requestKey](requestUrl, values);
				if (data) {
					return data;
				}
			} catch (e) {
				console.error(e);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		async onBrokersRemoveItem({ dispatch }, id) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.delete(`/broker/${ id }`);
				if (data.status) {
					dispatch('setAlert', { type: "success", message: "The removal was successful" });
				} else {
					dispatch('setAlert', { type: "error", message: "Deletion error" });
				}

				return data;
			} catch (e) {
				console.error(e);
			} finally {
				dispatch("actionPreloader", false);
			}
		},
		async getBrokersItem({ commit, dispatch }, id) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get(`/broker/${ id }/edit`);

				if (data && !data.status) {
					commit("updateBrokersItem", data);
				}
			} catch (error) {
				console.error(error);
			} finally {
				dispatch("actionPreloader", false);
			}
		}
	},
	getters: {
		brokersItem: (s) => s.brokersItem,
		brokersList: (s) => s.brokersList,
		brokersFilters: (s) => s.brokersFilters,
		brokersTotals: (s) => s.brokersTotals,
		brokersLimit: (s) => s.brokersLimit,
		brokersOrder: (s) => s.brokersOrder,
		brokersSort: (s) => s.brokersSort,
		brokersTotal: (s) => s.brokersTotal
	}
};
